import { NgModule } from '@angular/core';

import { HisTreeSharedModule } from './his-tree-shared.module';

/**
 * Library of tree components.
 */
@NgModule( {
    imports: [
        HisTreeSharedModule
    ],
    declarations: [
    ],
    exports: [
        HisTreeSharedModule
    ]
} )

export class HisTreeCoreModule {

}
